import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const TransactionDetailReport: React.FC = () => (
  <ReportPageShell
    reportType="transaction-detail"
    title="Transaction Detail Export"
    subtitle="Per-line export for accountant / audit review. XLSX only; window capped at 31 days per export."
    maxRangeDays={31}
    xlsxOnly
    bullets={[
      'Invoice, Date, Type, Voided flag',
      'Line: SKU, Product, Qty, Price',
      'Line totals: Discount, Net, Tax, Amount',
      'Refund Quantity + Line Voided flag',
      'Payments (JSON: tender, amount, voided, reference)',
    ]}
  />
);

export default TransactionDetailReport;
